var React = require('react');

function FieldHockey (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M628 0h-67.3a11.57 11.57 0 0 0-8.4 3.6L479 76.9 592 190l44.5-44.6a12.3 12.3 0 0 0 3.5-8.5V12a12 12 0 0 0-12-12zM480.2 320a96 96 0 1 0 95.9 96 95.94 95.94 0 0 0-95.9-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 319.2a190.68 190.68 0 0 1 56.2-135.8 79.94 79.94 0 0 1 113 113.1c-29.8 29.9 15.2 75.2 45.2 45.3l230.7-231 113 113.1-50.8 50.8c-99.6-19.1-187.4 68-168.1 168.5-14.9 14.8-61.3 68-147.4 68-106.2 0-191.8-86-191.8-192z","className":"fa-primary","key":2})]);
}

FieldHockey.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = FieldHockey;

FieldHockey.default = FieldHockey;
